var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTransition = function SvgIconTransition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M19.029 16.592 19.006 6.52a2.58 2.58 0 0 0-.708-1.778 2.34 2.34 0 0 0-1.698-.734l-1.6.004a2.35 2.35 0 0 0-1.696.741 2.58 2.58 0 0 0-.699 1.782l.024 10.072c.002.667.256 1.307.707 1.778a2.34 2.34 0 0 0 1.699.734l1.6-.004a2.34 2.34 0 0 0 1.695-.741c.45-.474.7-1.115.699-1.782Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.8 4.03-1.6.004a3.13 3.13 0 0 0-2.26.988 3.44 3.44 0 0 0-.932 2.376l.02 8.393c.002.89.34 1.743.942 2.371s1.417.98 2.265.978l1.6-.004m4.783-7.564-6.4.015m0 0 2.394-2.524m-2.394 2.524 2.406 2.512"
  })));
};
export default SvgIconTransition;